import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, tap } from "rxjs/operators";
import { TokenService } from "../services/token.service";
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  retryTime: number = 0;
  constructor(private tokenService: TokenService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenService.getRawToken();
    if (
      token &&
      !request.url.includes("Login") &&
      !request.url.includes("GetPrinters") &&
      !request.url.includes("UpdateSoftware") &&
      !request.url.includes("PrinterQueue") &&
      !request.url.includes("TestConnection") &&
      !request.url.includes("PrintDocument") &&
      !request.url.includes("https://api.neshan.org")
    ) {
      request = request.clone({
        headers: request.headers
          .set("Authorization", `Bearer ${token}`)
          .set("Cache-Control", "no-cache, no-store, must-revalidate, post-check=0, pre-check=0")
          .set("Pragma", "no-cache")
          .set("Expires", "0"),
      });
      const start = window.performance.now();
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || (error.status === 503 && this.retryTime === 0)) {
            console.log("error.status", error.status);
            console.log(error.error);
            this.retryTime += 1;
            this.router.navigate(["auth/login"]).then(() => {
              window.location.reload();
            });
          }

          // this.logApiTimes(start, request);
          return throwError(error);
        }),
        tap((x) => {
          // this.logApiTimes(start, request);
        })
      );
    } else {
      const start = window.performance.now();
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || (error.status === 503 && this.retryTime === 0)) {
            console.log(error.error);
            this.retryTime += 1;
            console.log("error.status", error.status);
            this.router.navigate(["auth/login"]).then(() => {
              window.location.reload();
            });
          }
          // this.logApiTimes(start, request);
          return throwError(error);
        }),
        tap((x) => {
          // this.logApiTimes(start, request);
        })
      );
    }
  }

  private logApiTimes(start: number, request: HttpRequest<any>) {
    const end = window.performance.now();
    const time = end - start;
    let css = "";
    if (time <= 1600) {
      css = "color: #57b1ee; font-size: 12px";
    } else if (time <= 3000) {
      css = "color: #ff6358; font-size: 12px";
    } else if (time > 3000 && time <= 5000) {
      css = "color: red; font-size: 12px";
    } else if (time > 5000) {
      css = "background-image: linear-gradient(to bottom right, #699167, #cf0000);color: #fff; font-size: 12px";
    }
    console.log("%c API URL " + request.url.substring(request.url.indexOf("api")) + "===> " + time, css);
  }
}
